module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-594.fb542d0.woff2";